import React from 'react'
import '../Styles/JuniorCampPage1.scss';

function JuniorCampPage1() {
   return (
      <div className="juniorCampPage1Content">
         <div className="juniorCampPage1Container">
            <div className="juniorCampPage1Title">
               Junior Overnight Camp
            </div>
            <div div className="juniorCampPage1Description">
               Elementary aged children can come experience an amazing week <br></br>
               There is a wide variety of activities from swimming to horseback riding.<br></br>
               Most importantly, campers are challenged through daily Bible preaching
            </div>
            <div className="juniorCampPage1WeeksContainer">
               <div className="juniorCampPage1Weeks">
                  <div className="juniorCampWeek1">
                     <div className="juniorWeek1Title">
                        Week One
                     </div>
                     <div className="juniorWeek1Content">
                        June 12 - June 16, 2023
                     </div>
                  </div>

                  <div className="vl"></div>

                  <div className="juniorCampWeek2">
                     <div className="juniorWeek2Title">
                        Week Two
                     </div>
                     <div className="juniorWeek2Content">
                        June 26 - June 30, 2023
                     </div>
                  </div>

                  <div className="vl"></div>

                  <div className="juniorCampWeek3">
                     <div className="juniorWeek3Title">
                        Week Three
                     </div>
                     <div className="juniorWeek3Content">
                        July 10 - July 14, 2023
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
export default JuniorCampPage1;
